<div class="polaris-select">
  @if (value) {
    <span class="polaris-select__text">
      <span class="polaris-select__label">{{ label }}</span>
      <span class="polaris-select__value">{{ value }}</span>
    </span>
  } @else {
    <span class="polaris-select__placeholder">{{ label }}</span>
  }
  <i class="polaris-select__chevron icon icon-arrow_down"></i>
</div>
